<template>
  <Component :is="helpFormComponents[mode]" v-bind="$attrs">
    <template v-if="$attrs.maxlength" #label="{ label, labelClasses }">
      <div class="flex">
        <label v-if="label" :class="[labelClasses, 'flex-none']">{{ label }}</label>
        <div class="mb-1 flex w-full justify-end text-sm font-semibold text-p-gray-40">
          {{ charCountdown }}
        </div>
      </div>
    </template>
  </Component>
</template>

<script setup lang="ts">
import { PInput, PTextarea } from '@pequity/squirrel';
import { computed, useAttrs } from 'vue';

defineOptions({
  name: 'HelpFormInput',
  inheritAttrs: false,
});

type HelpFormInputMode = 'PInput' | 'PTextarea';

type Props = {
  mode?: HelpFormInputMode;
};

withDefaults(defineProps<Props>(), {
  mode: 'PInput',
});

const attrs = useAttrs();

const helpFormComponents = { PInput, PTextarea };

const charCountdown = computed(() => {
  const charsLeft = Number(attrs.maxlength) - (attrs.modelValue as string).length || 0;

  return charsLeft > 0 ? charsLeft : 0;
});
</script>
